import React from "react";
import { IReviewQuizProps, IReviewQuizState, IRootState } from "../../interfaces";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { reviewQuizRequest } from "../../action";
import { Table } from "react-bootstrap";
import Loader from "../../components/Loader/Loader";
import { toast } from 'react-toastify';

class Review_Quiz extends React.Component<IReviewQuizProps, IReviewQuizState> {
  constructor(props: any) {
    super(props);
    this.state = {
      questions: {},
      userAnswer: {},
      currentQues: 1,
      maxQuestions: 80,
      quizSummaryData: {},
    };
  }

  componentDidMount() {
    this.getQuizData();
  }

  componentDidUpdate = (prevProps: any) => {
    const { reviewQuizReducer } = this.props;
    if (
      reviewQuizReducer &&
      reviewQuizReducer.quizData &&
      Object.entries(reviewQuizReducer.quizData).length
    ) {
      const { quizData } = reviewQuizReducer;
      if (!this.state.questions[0]) {
        this.setState({
          questions: quizData,
          maxQuestions: quizData.length,
        });
        for (var i = 0; i < quizData.length; i++) {
          this.state.userAnswer[quizData[i].id] = ""; 
        }
      }
    }
  };

  getQuizData = () => {
    const { reviewQuizReducer } = this.props;
    if (reviewQuizReducer) {
      if (this.props.quizData) {
        this.props.quizData();
        console.log("Hello there",this.props.quizData(), this.props.quizData)
      }
    }
  };

  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    this.setState({
      ...this.state,
      [name]: value,
    });
  };

  handleNextButton = () => {
    if (this.state.currentQues < this.state.maxQuestions) {
      this.setState({
        currentQues: this.state.currentQues + 1,
      });
    }
  };

  handlePrevButton = () => {
    if (this.state.currentQues > 1) {
      this.setState({
        currentQues: this.state.currentQues - 1,
      });
    }
  };

  handleQuizSubmit = () => {
    let element: HTMLElement = document.getElementsByClassName("swal2-container")[0] as HTMLElement;
    if(element) {
      element.style.display = "none";
    }
    toast.dismiss();
    const {
      userAnswer,
    } = this.state;
    const { submitQuizData } = this.props;

    if (submitQuizData) {
      this.setState({
        userAnswer: this.state.userAnswer
      });
      const data = {
        userAnswer
      };
     submitQuizData({
        ...data
      });
      //const { reviewQuizReducer } = this.props;
    }
  };

  createChoices(item:any) {
    if(item.choices) {
      var alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
      return Object.keys(item.choices).map((key, i) => (
        <div className="row choice-row">
            <div className="col-lg-12 col-md-12">
              <div
                id={`${item.id}_${i+1}`}
                className="col-lg-10 col-md-10 col-sm-10 ml-new5 choice choice-nopointer"
              >
                <Table
                  responsive
                  className="choice-table"
                  cellSpacing="0"
                  cellPadding="0"
                >
                  <tbody>
                    <tr>
      <td className="choice-alphabet">{alphabets[i]}</td>
                      <td className="choice-desc">
                        <div className="choice-text">
                          {item.choices[key]}
                        </div>
                        {item.choiceStatus[i] === "tick" ? 
                        <div
                          className="social-networks"
                        >
                          <i>&#10004;</i>
                        </div>
                        :""
                      }
                      {item.choiceStatus[i] === "wrong" ?
                        <div
                          className="wrong-tick"
                          
                        >
                          <i>&#10005;</i>
                        </div>
                        :""}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
      ))
    }
  }

  render() {
    return (
      <>
        <div className="main-section module-custom-main" id="right-container">
          <div className="col-lg-12 col-md-12">
            <div className="container">
              <div className="title video-search">
                <div className="row">
                  <div className="quiz-head-section">
                    <h4 className="video-title">
                      Quiz Review
                      <span className="border-heading"></span>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <section className="">
              {this.state.questions && !this.state.questions[0] ? (
                <Loader />
              ) : (
                this.state.questions.map((item: any, index: any) => (
                  <div
                    className={
                      this.state.currentQues === index + 1
                        ? "container"
                        : "container hide-element"
                    }
                  >
                    <div className="row">
                      <div className="col-lg-12 col-md-12 mr-5 mt-3 ml-new5 mb-3">
                        <span className="mr-3 question">
                          {index + 1}.{item.question}
                        </span>
                      </div>
                    </div>

                    {this.createChoices(item)}

                    <div className="row">
                      <div className="col-lg-10 col-md-10 ml-new5 mt-3 btn-row">
                        <span>
                          <button
                            className={
                              this.state.currentQues === 1
                                ? "btn prev-btn mb-5 ml-auto hide-element"
                                : "btn prev-btn mb-5 ml-auto"
                            }
                            type="submit"
                            onClick={() => {
                              this.handlePrevButton();
                            }}
                          >
                            Previous Question
                          </button>
                        </span>
                        <span>
                          <button
                            className={
                              this.state.currentQues === this.state.maxQuestions
                                ? "btn next-btn mb-5 ml-auto hide-element"
                                : "btn next-btn mb-5 ml-auto"
                            }
                            type="submit"
                            onClick={() => {
                              this.handleNextButton();
                            }}
                          >
                            Next Question
                          </button>
                        </span>
                      </div>
                    </div>
                    <div className="row choice-row">
                      <div className="col-lg-12 col-md-12">
                      <div className="col-lg-10 col-md-10 col-sm-10 ml-new5 answerDesc">
                          <div className="answerDesc-heading">{item.correct === true ? "This answer is correct" :"This answer is not correct"}</div>
                          <div className="answer-content">{item.answerDesc}</div>
                          </div>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </section>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps: any = (state: IRootState) => ({
  reviewQuizReducer: state.reviewQuizReducer,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    quizData: () => {
      dispatch(reviewQuizRequest());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Review_Quiz);
